import { GET } from '@/api';

const URL = '/product/compare';

export default async ({ code = '', config, successCB, failCB }) => {
  try {
    const { data } = await GET(`${URL}?productCode=${code}`, config);
    return (typeof successCB === 'function' && successCB(data)) || data;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
